import React, { Component } from 'react';
import _ from 'lodash';
import {
  Button,
} from 'reactstrap';
import PropTypes from 'prop-types';
import Utility from './Utility';
import RFField from '../../../components/Form/RFField';

class Selector extends Component {
  constructor(props) {
    super(props);
  }

  handleSelectorSelectEvent = (event) => {
    const options = event.target.options;
    const option = options[options.selectedIndex];
    this.props.loadElementSelected({ value: option.value, name: option.text });
  }

  handleVisszaigazolasClick = (event) => {
    // a change előtti érték van az event.value-ben eltárolva, ezért meg van cserélve az eltárolt érték
    this.props.setState({ visszaigazolasCheck: event.target.value == 'true' ? false : true });
  }

  // convertSelectedToOption-t és convertOptionToSelected-t együtt kell változtatni
  convertSelectedToOption = (elementSelected, visszaigazolasCheck) => {
    let check = '';
    if (this.props.useCheckbox)
      check = Utility.convertCheckBooleanToString(visszaigazolasCheck);
    return <option value={elementSelected.value}>{elementSelected.name + check}</option>;
  }

  convertOptionToSelected = (target) => {
    const { text } = target;
    // A textben lévő pipa/X alapján van eldöntve, hogy a visszaigazolás pipa értéke mi legyen
    return {
      value: target.value,
      name: this.props.useCheckbox ? text.slice(0, text.length - 4) : text,
      check: this.props.useCheckbox ? text.substr(text.length - 2, 1) !== 'X' : false
    };
  }

  selectElement = (event) => {
    const { target } = event;
    if (target.tagName == "OPTION") {
      const select = this.convertOptionToSelected(target);
      this.props.setState({
        elementSelected: select,
        visszaigazolasCheck: select.check
      });
    }
  }

  addElement = () => {
    const {
      elementSelected,
      list,
      visszaigazolasCheck
    } = this.props.stateData;
    let listAlt = Array.from(list);
    Utility.insertByOrder(listAlt, this.convertSelectedToOption(elementSelected, this.props.useCheckbox ? visszaigazolasCheck : null));
    this.props.setState({ list: listAlt, visszaigazolasCheck: false, elementSelected: null });
  }

  editElement = () => {
    const {
      elementSelected,
      list,
      visszaigazolasCheck
    } = this.props.stateData;
    let listAlt = Array.from(list);
    for (let i = listAlt.length; i--;) {
      if (listAlt[i].props.value == elementSelected.value) {
        listAlt.splice(i, 1, this.convertSelectedToOption(elementSelected, this.props.useCheckbox ? visszaigazolasCheck : null));
        break;
      }
    }
    this.props.setState({ list: listAlt });
  }

  deleteElement = () => {
    const {
      elementSelected,
      list
    } = this.props.stateData;
    let listAlt = Array.from(list);
    if (elementSelected) {
      for (let i = listAlt.length; i--;) {
        const element = listAlt[i];
        if (element.props.value == elementSelected.value) {
          listAlt.splice(i, 1);
          break;
        }
      }
    }
    this.props.setState({ list: listAlt, visszaigazolasCheck: false, elementSelected: null });
  }

  elementIsPresentInList = () => {
    const {
      elementSelected,
      list
    } = this.props.stateData;
    if (elementSelected)
      for (let listElement of list)
        if (listElement.props.value == elementSelected.value)
          return true;
    return false;
  }

  render() {
    const {
      disabled,
      listLabel,
      selectorDefaultOptionName,
      selectorLabel,
      selectorTitle,
      stateData,
      type
    } = this.props;
    const {
      elementSelected,
      list,
      options,
      visszaigazolasCheck,
    } = stateData;
    const edit = this.elementIsPresentInList();
    const useCheckbox = this.props.useCheckbox == true;
    return (
      <>
        <h4>{selectorTitle}</h4>
        <div className="col-md-12">
          <div className="row align-items-center">
            <div
              className="col"
              style={{ paddingLeft: 0, paddingRight: 0 }}>
              <RFField
                label={selectorLabel}
                type="select"
                name="selector"
                value={elementSelected ? elementSelected.value : "default"}
                onChange={this.handleSelectorSelectEvent}
                disabled={disabled}
                defaultSelect={<option value="default">{selectorDefaultOptionName}</option>}
                selectOptions={options}
              />
            </div>
            {this.props.useCheckbox &&
              <div className='col-auto' style={{ marginTop: 13, paddingLeft: '10px' }}>
                <RFField
                  label="Visszaigazolás"
                  type="checkbox"
                  name="visszaigazolas"
                  onChange={this.handleVisszaigazolasClick}
                  value={visszaigazolasCheck}
                  checked={visszaigazolasCheck}
                />
              </div>
            }
            <div className='col-auto' style={{ marginTop: 13, paddingLeft: '10px' }}>
              <Button
                type="button"
                id="UjMezo"
                className="btn-cursor-pointer"
                color="success"
                onClick={edit ? this.editElement : this.addElement}
                disabled={!elementSelected || elementSelected.value == 'default' || !useCheckbox && edit}
              >
                {edit && useCheckbox ? "Módosítás" : "Hozzáadás"}
              </Button>
            </div>
            {edit &&
              <div className='col-auto' style={{ marginTop: 13, paddingLeft: '15px' }}>
                <Button type="button" id="torles" className="btn-danger" onClick={this.deleteElement}><i className="fa fa-trash" /></Button>
              </div>
            }
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <RFField
              type="select"
              name="list"
              label={listLabel}
              multiple
              onClick={this.selectElement}
              style={{ height: '100px' }}
              selectOptions={list}
            />
          </div>
        </div>
      </>
    );
  }
}

Selector.propTypes = {
  disabled: PropTypes.bool,
  listLabel: PropTypes.string,
  // A szükséges state mezőbe elmenti a visszatérési értéket
  loadElementSelected: PropTypes.func,
  selectorDefaultOptionName: PropTypes.string,
  selectorLabel: PropTypes.string,
  // State-t frissíti a paraméter objektummal
  setState: PropTypes.func,
  // A state-ben tárolt szükséges adatok
  stateData: PropTypes.object,
  useCheckbox: PropTypes.bool,
};

export default Selector;